<template>
  <div class="tutorial">
    <transition @enter="enter" @leave="leave" mode="out-in" appear>
      <section
        class="tutorial__container"
        :key="$store.state.tutorial"
      >

        <p
          class="tutorial__content"
          v-html="$translate('tutorial').content[$store.state.tutorial]"
        />

        <div class="tutorial__bottles" :class="{ 'tutorial__bottles--app' : $inApp }" v-if="$store.state.tutorial === 2">
          <img src="/img/tutorial/bottle-left.png" alt="Powerup pink bottle">
          <img src="/img/tutorial/bottle-center.png" alt="Powerup red bottle">
          <img src="/img/tutorial/bottle-right.png" alt="Powerup yellow bottle">
        </div>

        <div class="tutorial__icon" v-else>
          <p class="icon__text" v-html="$translate('tutorial').button" v-if="$store.state.tutorial === 0" />

          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 116 116">
            <circle
              class="icon__circle"
              cx="58" cy="58" r="57"
              fill="none"
            />
            <path
              class="icon__arrow"
              d="M29.5,62.5l-9-4.5l9-4.5v4h17v1h-17V62.5z"
              v-if="$store.state.tutorial === 1"
            />
            <path
              class="icon__arrow"
              d="M86.5,53.5l9,4.5l-9,4.5v-4h-17v-1h17V53.5z"
              v-if="$store.state.tutorial === 1"
            />
          </svg>
        </div>

        <button
          class="tutorial__button tutorial__button--underline"
          @click="skipTutorial"
          v-if="$store.state.tutorial === 0 || $store.state.tutorial === 1"
        >
          {{ $translate('tutorial').close }}
        </button>
      </section>
    </transition>
  </div>
</template>

<script>
import gsap from 'gsap/gsap-core';
import { initials, enter, leave } from '@/scripts/animations';

export default {
  name: 'UItutorial',

  mounted() {
    localStorage.setItem('GucciBloomTutorialDone', 1);
  },

  methods: {
    enter(el, done) {
      const content = el.querySelector('.tutorial__content');
      const icon = el.querySelector('.tutorial__icon');
      const button = el.querySelector('.tutorial__button');
      const bottlesConteiner = el.querySelector('.tutorial__bottles');
      const tl = gsap.timeline({ onComplete: done });
      initials.get('fade')(content);
      gsap.set(icon, { scale: 0, transformOrigin: '50% 50% 0' });

      tl.addLabel('start')
        .add(enter.get('fade')(content), 'start');

      if (icon) {
        tl.to(icon, {
          scale: 1,
          duration: 1.5,
          ease: 'bloom',
        }, 'start+=0.3');
      }

      if (button && button.classList.contains('tutorial__button--underline')) {
        initials.get('fade')(content);
        tl.add(enter.get('fade')(content), 'start+=0.6');
      }

      if (bottlesConteiner) {
        const bottles = bottlesConteiner.querySelectorAll('img');

        gsap.set(bottles[0], { x: 35 });
        gsap.set(bottles[2], { x: -35 });
        gsap.set(bottles, { y: 50, autoAlpha: 0 });

        tl.to(bottles, {
          x: 0,
          y: 0,
          autoAlpha: 1,
          duration: 1.5,
          ease: 'bloom',
        }, 'start+=0.4');
      }
    },
    leave(el, done) {
      leave.get('fade')(el, 0).then(done);
    },
    skipTutorial() {
      this.$store.commit('SET_TUTORIAL', 3);
      this.$game.startSpawning();
    },
  },
};
</script>

<style lang="scss" scoped>
.tutorial {
  color: $white;
  text-align: center;
  font-weight: normal;
  @extend %font-small;

  @include gradient-bg(0.6);
  @extend %background-grain;

  pointer-events: none;

  &__container {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__bottles,
  &__icon {
    position: absolute;
    left: 50%;

    transform: translateX(-50%);
  }

  &__icon {
    bottom: 100px;

    .icon__text {
      position: absolute;
      top: 50%;
      left: 50%;

      transform: translateX(-50%) translateY(-50%);
    }

    svg {
      position: relative;
      width: 115px;
    }

    circle {
      stroke-width: 1px;
      stroke: $white;
    }

    path {
      fill: $white;
    }
  }

  &__bottles {
    bottom: 100px;
    width: 14vw;
    min-width: 80px;
    max-width: 250px;

    &--app {
      bottom: 135px;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;

      &:first-child {
        position: relative;
      }
    }
  }

  &__button {
    position: absolute;
    bottom: 20px;
    left: 50%;
    padding: 5px;

    background-color: transparent;
    @extend %font-small-but;

    transform: translateX(-50%);

    pointer-events: auto;
    cursor: pointer;

    &--underline {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  @include mq(ipadP) {
    &__bottles {
      bottom: 135px;
    }
    &__button {
      bottom: 30px;
    }

    svg {
      width: 150px;
    }
  }

  @include mq(dm) {
    &__button {
      bottom: 40px;
    }

    svg {
      width: 180px;
    }
  }
}
</style>
